"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackFlightReqBody = exports.TrackedFlightType = exports.TrackFlightsSettings = exports.PriceDiffTypes = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
var PriceDiffTypes;
(function (PriceDiffTypes) {
    PriceDiffTypes["ACT"] = "actual";
    PriceDiffTypes["PCT"] = "percentage";
})(PriceDiffTypes = exports.PriceDiffTypes || (exports.PriceDiffTypes = {}));
class PriceDiff {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], PriceDiff.prototype, "value", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(PriceDiffTypes),
    __metadata("design:type", String)
], PriceDiff.prototype, "type", void 0);
class TrackFlightsSettings {
}
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TrackFlightsSettings.prototype, "receiveNotifications", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PriceDiff),
    __metadata("design:type", PriceDiff)
], TrackFlightsSettings.prototype, "priceDiff", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackFlightsSettings.prototype, "stopDaysBefore", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TrackFlightsSettings.prototype, "sameFlightsOnly", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TrackFlightsSettings.prototype, "sameSourceOnly", void 0);
exports.TrackFlightsSettings = TrackFlightsSettings;
class TrackedFlightType {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightType.prototype, "type", void 0);
exports.TrackedFlightType = TrackedFlightType;
class FlightSearchParams {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightSearchParams.prototype, "startCode", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightSearchParams.prototype, "endCode", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightSearchParams.prototype, "startDate", void 0);
class TrackedFlightDepArrAirport {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightDepArrAirport.prototype, "time", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightDepArrAirport.prototype, "airportCode", void 0);
class TrackedFlightStop {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightStop.prototype, "airportCode", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackedFlightStop.prototype, "layoverMs", void 0);
class TrackedFlightCarrier {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightCarrier.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TrackedFlightCarrier.prototype, "name", void 0);
class TrackedFlightSegmentAirport {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightSegmentAirport.prototype, "iata", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TrackedFlightSegmentAirport.prototype, "municipality", void 0);
class TrackedFlightSegment {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightSegment.prototype, "flightNumber", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightCarrier),
    __metadata("design:type", TrackedFlightCarrier)
], TrackedFlightSegment.prototype, "carrier", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightSegmentAirport),
    __metadata("design:type", TrackedFlightSegmentAirport)
], TrackedFlightSegment.prototype, "origin", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightSegmentAirport),
    __metadata("design:type", TrackedFlightSegmentAirport)
], TrackedFlightSegment.prototype, "dest", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackedFlightSegment.prototype, "flightTime", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackedFlightSegment.prototype, "operatingCarrierName", void 0);
class TrackFlightReqBody {
}
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => FlightSearchParams),
    __metadata("design:type", FlightSearchParams)
], TrackFlightReqBody.prototype, "searchParams", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackFlightReqBody.prototype, "uid", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], TrackFlightReqBody.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightType),
    __metadata("design:type", TrackedFlightType)
], TrackFlightReqBody.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightDepArrAirport),
    __metadata("design:type", TrackedFlightDepArrAirport)
], TrackFlightReqBody.prototype, "departure", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightDepArrAirport),
    __metadata("design:type", TrackedFlightDepArrAirport)
], TrackFlightReqBody.prototype, "arrival", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightStop),
    __metadata("design:type", Array)
], TrackFlightReqBody.prototype, "stops", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackFlightReqBody.prototype, "priceInUSD", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => TrackedFlightSegment),
    __metadata("design:type", Array)
], TrackFlightReqBody.prototype, "segments", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackFlightReqBody.prototype, "totalFlightTime", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TrackFlightReqBody.prototype, "totalCO2", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], TrackFlightReqBody.prototype, "numSeatsAvailable", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], TrackFlightReqBody.prototype, "cabinClass", void 0);
exports.TrackFlightReqBody = TrackFlightReqBody;
